import { z } from 'zod';
export const SourceEnumSchema = z.enum(['Open AI Deep Research', 'Gemini, 2025']);
export const BehindTheAnswerWidgetSchema = z.object({
    mainTakeAway: z.string().describe('The main takeaway or summary'),
    personaTitle: z.string().optional().describe('Persona title (label), if available'),
    segmentName: z.string().describe('Name of the segment'),
    caresAbout: z
        .array(z.object({
        title: z.string().describe('Section title'),
        description: z.string().describe('Section description'),
    }))
        .optional()
        .describe('What the persona cares about based on the persona characteristics'),
    sources: z
        .array(z.object({
        source: SourceEnumSchema,
        evidence: z.array(z.string()).describe('Array of evidence points from this source'),
    }))
        .optional()
        .describe('List of sources with their evidence'),
});
export const BehindTheAnswerWidgetKey = 'behind-the-answer-widget:v1';
export const BehindTheAnswerWidgetKind = 'insight';
